import { atom, useRecoilCallback, useRecoilValue } from 'recoil';

const prebuiltDebuggerEnabledState = atom<boolean>({
  key: 'prebuilt-debugger-enabled',
  default: false,
});

export const useDebugging = () => {
  const prebuiltDebuggerEnabled = useRecoilValue(prebuiltDebuggerEnabledState);
  const enablePrebuiltDebugger = useRecoilCallback(({ set }) => () => {
    set(prebuiltDebuggerEnabledState, true);
  });
  const disablePrebuiltDebugger = useRecoilCallback(({ set }) => () => {
    set(prebuiltDebuggerEnabledState, false);
  });

  return {
    prebuiltDebuggerEnabled,
    enablePrebuiltDebugger,
    disablePrebuiltDebugger,
  };
};
